<template>
    <div :class="preCls + 'content-box'">
        <Tabs class="router-view" :animated="false" v-model="active">
            <TabPane :key="order" :label="order" :name="order">
                <order-form
                    :id="this.id"
                    :workOrderEntity="this.workOrder"
                ></order-form>
            </TabPane>

            <TabPane
                :key="orderProcess"
                :label="orderProcess"
                :name="orderProcess"
            >
                <order-process
                    :id="this.id"
                    :workOrderEntity="this.workOrder"
                ></order-process>
            </TabPane>

            <TabPane :key="orderFee" :label="orderFee" :name="orderFee">
                <order-fee
                    :id="this.id"
                    :workOrderEntity="this.workOrder"
                ></order-fee>
            </TabPane>
        </Tabs>
    </div>
</template>

<script>
import mTab from '@/views/common/m-tab'
import orderForm from '_v/work-order/order-form'
import orderProcess from '_v/work-order/order-process'
import orderFee from '_v/work-order/order-fee'
export default {
    mixins: [mTab],
    props: {
        id: {
            type: [String],
            default: '',
        },
        workOrder: {
            type: [Object],
            default: () => {},
        },
    },
    components: {
        orderForm,
        orderProcess,
        orderFee,
    },
    data() {
        return {
            active: 'order',
            order: '工单信息',
            orderProcess: '执行进度',
            orderFee: '相关费用',
        }
    },
}
</script>
